<fieldset [formGroup]="form()">
  <legend class="h5 p-0">{{ 'label_package' | translate }} <span class="color-error">*</span></legend>
  <ds-checkbox
    class="mb-3"
    data-test-id="legacy-customer-checkbox"
    [label]="'legacy_customer_label' | translate"
    [isSelected]="showLegacyCustomerPackages()"
    (valueChange)="toggleLegacyCustomerPackages($event)"
  ></ds-checkbox>
  <div class="d-flex flex-wrap gap-4">
    @for (displayPackage of displayPackages(); track displayPackage[$package._id]) {
      <label
        class="info-box package-radio-item flex-row p-3 align-items-start"
        [class.active]="isPackageSelected(displayPackage)"
        [class.disabled]="isDisabled()"
        [attr.aria-disabled]="isDisabled()"
        data-test-id="package-radio-item"
      >
        <span data-test-id="package-name">{{ displayPackage[$package.name] }}</span>
        <input
          type="radio"
          [value]="displayPackage"
          [attr.name]="fieldName()"
          [formControlName]="fieldName()"
          [id]="displayPackage[$package._id] + '-radio'"
          [attr.disabled]="isDisabled() ? true : null"
          (change)="onPackageChange(displayPackage)"
        />
      </label>
    }
  </div>
  <app-form-field-error
    [formValidationRequest$]="formValidationRequest$()"
    [field]="form().get(fieldName())"
    [name]="fieldName()"
    [label]="'label_package'"
  ></app-form-field-error>
</fieldset>
